import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class ModerationOperators extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId, flowId }) {
        if (!flowId) {
            return `/ticket/organizations/${organizationId}/moderation_flows/users`;
        }
        return `/ticket/organizations/${organizationId}/moderation_flows/${flowId}/users`;
    }

    static getLogs({ organizationId, query }) {
        return fetcher.get(`/ticket/organizations/${organizationId}/moderation_flows/moderation_logs`, {
            query: query,
            headers: { Accept: 'text/csv' }
        });
    }
    resolveOperatorName() {
        return `${this.first_name} ${this.last_name}`;
    }

    toOptions() {
        return {
            key: this.username,
            text: this.resolveOperatorName(),
            value: this.username,
            name: this.username
        };
    }
}
